import {
  concretiseParams,
  dateTimeProducer,
  updateSearchParamsWithFilters,
} from "../filters/filters"
import { updateSearchParamsWithPagination } from "../../page"
import { API_BASE_URL } from "../../app/config"
import { getToken, handleSignIn } from "../iam/middleware"

/**
 * Get passes for objects over Astrosites
 * Note these are visible passes at night (for the Astrosite location).
 *
 * @param filers  // filters to apply
 * @param page  // pagination settings
 * @returns {Promise<any>}
 */
export const getPasses = async ({ filter = {}, page = {} }) => {
  // Build parameter set
  const params = new URLSearchParams()
  // Add the relevant filters
  updateSearchParamsWithFilters(params, filter)
  // Replace any relative ones with absolute ones
  concretiseParams(params)
  // Pagination control
  updateSearchParamsWithPagination(params, page)

  let resp = await fetch(`${API_BASE_URL}/api/passes?${params.toString()}`, {
    method: "GET",
    mode: "cors",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    redirect: "error",
  })

  resp = handleSignIn(resp)
  return resp.json()
}

/**
 * Generate passes for the requested norad_ids over the next 7 days
 * @param noradIds
 * @returns {Promise<any>}
 */
export const generatePasses = async ({ norad_ids = [], from, to }) => {
  let resp = await fetch(`${API_BASE_URL}/api/passes`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify({
      norad_ids: norad_ids?.map((id) => id.toString()),
      from: dateTimeProducer[from](),
      to: dateTimeProducer[to](),
    }),
    redirect: "error",
  })
  resp = handleSignIn(resp)
  return resp.json()
}
